export default class MobileNav extends HTMLDivElement {
    stack;
    backBtn;
    titleEl;
    history;
    index;

    constructor() {
        super();

        const _this = this;

        _this.stack = _this.querySelector('.nm-stack');
        _this.backBtn = _this.querySelector('.nm-back');
        _this.titleEl = _this.querySelector('#mobileNavLabel');
        _this.history = [];
        _this.index = 0;

        this.querySelectorAll('.nm-panel').forEach(p => {
            if (p.parentElement !== _this.stack) {
                _this.stack.appendChild(p);
            }
        });
    }

    connectedCallback() {
        this.events();
    }

    goTo(panelId, push = true) {
        const _this = this;
        const panel = _this.querySelector('#' + panelId);

        if (!panel) {
            return;
        }

        if (push) {
            panel.style.setProperty('display', 'block');
        }

        _this.index += push ? 1 : -1;
        _this.index = Math.max(0, _this.index);
        _this.stack.style.setProperty('--nm-index', _this.index);

        const t = panel.getAttribute('data-title') || 'Navigation';
        _this.titleEl.textContent = t;

        _this.backBtn.classList.toggle('d-none', _this.index === 0);

        if (push) {
            _this.history.push(panelId);
        } else {
            const oldPanelId = _this.history.pop();

            _this.querySelector('#' + oldPanelId).style.setProperty('display', 'none');
        }

        _this.querySelectorAll('.nm-panel').forEach(p => p.classList.remove('is-active'));
        panel.classList.add('is-active');
    }

    // Initialisation events de la mobileNav
    events() {
        const _this = this;

        _this.addEventListener('click', (e) => {
            const a = e.target.closest('a.nm-next:not(.corpo)');

            if (!a || a.parentElement?.matches('li.corpo')) {
                return;
            }

            e.preventDefault();
            const target = a.getAttribute('data-target');

            if (target) {
                _this.goTo(target, true);
            }
        });

        _this.backBtn.addEventListener('click', () => {
            if (_this.index === 0) {
                return;
            }

            const parentId = _this.history[_this.history.length - 2] || 'nm-root';

            _this.goTo(parentId, false);
        });

        _this.addEventListener('shown.bs.offcanvas', () => {
            _this.index = 0;
            _this.history.length = 0;
            _this.stack.style.setProperty('--nm-index', 0);
            _this.backBtn.classList.add('d-none');
            _this.titleEl.textContent = _this.querySelector('#nm-root')?.dataset.title || 'Navigation';
            _this.querySelectorAll('.nm-panel').forEach(p => p.classList.remove('is-active'));
            _this.querySelector('#nm-root')?.classList.add('is-active');
        });

        let startX = 0, startY = 0, dragging = false;
        const SWIPE_THRESHOLD = 40;

        _this.stack.addEventListener('touchstart', (e) => {
            const t = e.changedTouches[0];
            startX = t.clientX; startY = t.clientY; dragging = true;
        }, {passive:true});

        _this.stack.addEventListener('touchend', (e) => {
            if (!dragging) {
                return;
            }

            dragging = false;
            const t = e.changedTouches[0];
            const dx = t.clientX - startX;
            const dy = Math.abs(t.clientY - startY);

            if (dx > SWIPE_THRESHOLD && dy < 60) {
                _this.backBtn.click();
            }
        }, {passive:true});
    }
}
